/**
 * Пейджвью на смену роута.
 *
 * Приложение — SPA: браузер грузит страницу один раз, дальше роуты меняются без
 * перезагрузки. PostHog снимает такие переходы сам, Метрика — нет, и без этого
 * компонента она засчитала бы один хит на всю рабочую сессию.
 *
 * Ядро само решает, кому из активных провайдеров отдать событие, поэтому здесь
 * нет ни одной проверки вида «а мы вообще на Метрике» — иначе разница между
 * инстансами протекла бы в дерево компонентов.
 *
 * Отдельным компонентом, а не хуком внутри App: правило проекта — не объявлять
 * компоненты внутри компонентов, и заодно App.js меняется на одну строку.
 */
import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageview } from './core';
import { analyticsUrl } from './url';

export default function PageviewTracker() {
  const { pathname, search } = useLocation();

  // Первый хит делает сама Метрика при init — и делает его уже с очищенным
  // адресом, потому что мы передаём url в параметрах инициализации явно
  // (см. providers/metrika.js). Дублировать его здесь не нужно, иначе входная
  // страница получит два просмотра вместо одного.
  const skippedFirst = useRef(false);

  useEffect(() => {
    if (!skippedFirst.current) {
      skippedFirst.current = true;
      return;
    }
    trackPageview(analyticsUrl(pathname, search));
  }, [pathname, search]);

  return null;
}
